(() => {
  'use strict';
  const gate = document.querySelector('[data-age-gate]');
  if (!gate || gate.dataset.initialized === 'true') return;
  gate.dataset.initialized = 'true';
  const preview = gate.dataset.preview === 'true';
  const key = 'mc_age_verified';
  const days = Math.min(365, Math.max(1, Number(gate.dataset.days) || 30));
  const ttl = days * 86400000;
  function valid(storage) {
    try {
      const record = JSON.parse(window[storage].getItem(key));
      const elapsed = Date.now() - record?.ts;
      return typeof record?.ts === 'number' && Number.isFinite(record.ts) && elapsed >= 0 && elapsed < ttl;
    } catch { return false; }
  }
  function remember() {
    const record = JSON.stringify({ ts: Date.now(), v: 1 });
    for (const storage of ['localStorage', 'sessionStorage']) {
      try { window[storage].setItem(key, record); } catch { /* Confirmation still works on this page. */ }
    }
  }
  function track(event) {
    if (preview) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, page_path: window.location.pathname });
    } catch { /* Telemetry must never prevent age confirmation. */ }
  }
  function resolved() { document.dispatchEvent(new CustomEvent('beerclub:age-resolved')); }
  if (!preview && (valid('localStorage') || valid('sessionStorage'))) {
    gate.dataset.ageState = 'verified'; resolved(); return;
  }
  const previousFocus = document.activeElement;
  if (typeof gate.showModal !== 'function') {
    // Unsupported browsers stay on an explicit blocked panel, not an invisible dialog.
    gate.setAttribute('open', '');
    gate.style.cssText = 'position:fixed;inset:16px;z-index:2147483647;margin:auto';
  } else gate.showModal();
  const html = document.documentElement, body = document.body;
  const siblings = [...body.children].filter(node => node !== gate && !['SCRIPT','STYLE','LINK'].includes(node.tagName));
  const savedInert = siblings.map(node => [node, node.inert]);
  siblings.forEach(node => { node.inert = true; });
  const scrollY = window.scrollY;
  const saved = ['position','top','left','width','overflow'].map(name => [name, body.style.getPropertyValue(name)]);
  body.style.setProperty('position','fixed'); body.style.setProperty('top',-scrollY+'px');
  body.style.setProperty('left','0'); body.style.setProperty('width','100%'); body.style.setProperty('overflow','hidden');
  html.classList.add('bc-age-open');
  document.getElementById('AgeVerificationTitle')?.focus({preventScroll:true});
  track('age_gate_shown');
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); return; }
    if (event.key !== 'Tab') return;
    const nodes = [...gate.querySelectorAll('button,a[href]')].filter(node => !node.closest('[hidden]') && !node.disabled);
    if (!nodes.length) return;
    const first = nodes[0], last = nodes.at(-1);
    if (event.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function unlock() {
    gate.dataset.ageState = 'verified';
    if (typeof gate.close === 'function') gate.close(); else gate.removeAttribute('open');
    html.classList.remove('bc-age-open');
    savedInert.forEach(([node, inert]) => { node.inert = inert; });
    saved.forEach(([name,value]) => value ? body.style.setProperty(name,value) : body.style.removeProperty(name));
    window.scrollTo({top:scrollY,behavior:'instant'});
    if (previousFocus && previousFocus !== body && !gate.contains(previousFocus)) previousFocus.focus({preventScroll:true});
    else document.getElementById('MainContent')?.focus({preventScroll:true});
    resolved();
  }
  gate.querySelector('[data-age-yes]').addEventListener('click', () => {
    if (gate.dataset.ageState !== 'pending') return;
    if (!preview) remember();
    unlock(); track('age_gate_verified');
  });
  gate.querySelector('[data-age-no]').addEventListener('click', () => {
    gate.dataset.ageState = 'denied';
    gate.querySelector('[data-age-question]').hidden = true;
    gate.querySelector('[data-age-denied]').hidden = false;
    gate.querySelector('.bc-age-denied-message').focus({preventScroll:true});
  });
  gate.querySelector('[data-age-preview-close]')?.addEventListener('click', unlock);
})();
